module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedMedium.ed6072b.ttf";